import { Injectable } from '@angular/core';
import * as I from '@interfaces';
import { 
	EnvironmentService,
	ErrorService,
	FuncServiceBase,
	SpinnerService,
	UrlService,
	UtilityService,
} from '@eforall/common';

//
//  This class is generated by generate-client-shims.mjs which is called
//  during the build. DON'T CHANGE IT MANUALLY.
//

@Injectable({ providedIn: 'root' })
export class FuncService extends FuncServiceBase {

	constructor(
		env: EnvironmentService,
		errorService: ErrorService,
		spinner: SpinnerService,
		url: UrlService,
		util: UtilityService,
) {
		super(env, errorService, spinner, url, util);
	}

	public appData = {
		get: this._callNoPayload<I.AppData>('appData.get'),
	};

	public dashboard = {
		create: this._call<I.NewDashboard, I.AppData>('dashboard.create'),
		getOptionsForNewDashboard: this._call<{ datasetId: I.DatasetId }, I.OptionsForNewDashboard>('dashboard.getOptionsForNewDashboard'),
		get: this._call<{ urlKey: string }, I.AppData>('dashboard.get'),
		update: this._call<I.DashboardMetadataChanges, I.Dashboard | undefined>('dashboard.update'),
	};

	public dataset = {
		getFieldsAndFilters: this._call<{ datasetId: I.DatasetId }, I.DataFieldAndFilter<unknown>[]>('dataset.getFieldsAndFilters'),
		getFiltersAffect: this._call<I.NewDashboard, I.DashboardFiltersAffect>('dataset.getFiltersAffect', { label: 'PROCESSING' }),
	};

	public vega = {
		add: this._call<{ urlKey: string }, I.Dashboard | undefined>('vega.add'),
		delete: this._call<{ urlKey: string }, I.Dashboard | undefined>('vega.delete'),
		update: this._call<{ urlKey: string }, I.Dashboard | undefined>('vega.update'),
	};

	public testBigQuery = this._callNoPayload<undefined>('testBigQuery');
}